<template>
	<div
		class="inline-flex flex-row-reverse items-center gap-6 p-4 rounded-lg bg-neutral-800"
	>
		<!-- Job profile -->
		<div class="flex items-center gap-2">
			<svg
				:width="dotSize"
				:height="dotSize"
				:viewBox="`0 0 ${dotSize} ${dotSize}`"
				class="overflow-visible shrink-0"
				role="img"
				aria-label="Job role"
			>
				<defs>
					<pattern
						id="jobDotsLegend"
						patternUnits="userSpaceOnUse"
						width="5"
						height="5"
					>
						<circle
							cx="3"
							cy="3"
							r="1"
							fill="rgba(255,255,255,0.75)"
						/>
					</pattern>
				</defs>

				<circle
					:cx="dotSize / 2"
					:cy="dotSize / 2"
					:r="dotSize / 2"
					fill="transparent"
					:stroke="strokeColor"
					:stroke-width="strokeWidth"
				/>
				<circle
					:cx="dotSize / 2"
					:cy="dotSize / 2"
					:r="dotSize / 2 - strokeWidth / 2"
					fill="url(#jobDotsLegend)"
				/>
			</svg>

			<span class="text-sm text-white">
				{{ $t('personality_results.mode.job_profile') }}
			</span>
		</div>

		<!-- Applicant -->
		<div class="flex items-center gap-2">
			<svg
				:width="dotSize"
				:height="dotSize"
				:viewBox="`0 0 ${dotSize} ${dotSize}`"
				class="overflow-visible shrink-0"
				role="img"
				:aria-label="$t('personality_results.mode.applicant')"
			>
				<circle
					:cx="dotSize / 2"
					:cy="dotSize / 2"
					:r="dotSize / 2"
					fill="transparent"
					:stroke="strokeColor"
					:stroke-width="strokeWidth"
				/>
			</svg>

			<span class="text-sm text-white">
				{{ $t('personality_results.mode.applicant') }}
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ComparisonLegend',
	props: {
		dotSize: {
			type: Number,
			required: false,
			default: 20
		},
		strokeWidth: {
			type: Number,
			required: false,
			default: 1
		},
		strokeColor: {
			type: String,
			required: false,
			default: '#fff'
		}
	}
}
</script>
